import { render, staticRenderFns } from "./KjcxView.vue?vue&type=template&id=47f3ad03&"
import script from "./KjcxView.vue?vue&type=script&lang=js&"
export * from "./KjcxView.vue?vue&type=script&lang=js&"
import style0 from "./KjcxView.vue?vue&type=style&index=0&id=47f3ad03&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports